import { Button, Form, Input, Radio, Space, Select, Row, Col, Avatar, Switch, Tooltip, Upload, Tabs } from 'antd';
import { Badge, FloatingLabel } from 'flowbite-react';
import { UserOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { FaSave } from 'react-icons/fa';
import { Link, useParams, useLoaderData, useOutletContext, useNavigate } from 'react-router-dom';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { MdEdit } from 'react-icons/md';
import { RxUpdate } from "react-icons/rx";
import EventEmitter from '../../utils/eventEmitter';
// import ContactAddress from '../modals/ContactAddress';
import useEmployeeAPI from '../apis/employeeAPI';



const EmployeeChanges = () => {
  const {employee, jobPositions, departments, employees, users, employeeTypes} = useLoaderData();
  const { success, error } = useOutletContext();
  const [form] = Form.useForm();
  const params = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState(employee.name ? employee.name : '');
  const { create, update } = useEmployeeAPI();
  

  const onChangeName = (e) => setName(e.target.value);

  const save = () => {
    let data = form.getFieldsValue();
    data['name'] = name;
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    create(data, success);
    // console.log(data);
  }

  const edit = () => { 
    let data = form.getFieldsValue();
    data['name'] = name;
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    update(employee.seo, data, success);
    // console.log(data)
  };

  useEffect(() => {
    EventEmitter.subscribe('employee_response', data => {
      navigate('/employee-app/employees/'+data);
    });
    
    return () => EventEmitter.unsubscribe('employee_response');
  },[])


  // console.log(departments)
  const openAddContactModal = () => {
    // EventEmitter.dispatch('create_contact_modal_open', true);
  }
  
  return (
    <div className='container mx-auto' style={{ maxWidth: '1000px' }}>
      <div className='flex justify-between'>
        <div>
          <h3 className='font-semibold'>
            <Link to={'/employee-app/employees'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Employees</Link> / {params.action}
            <Tooltip  title='save manually' placement='rightBottom' className='ms-1'>
            <Button onClick={save} type='text' htmlType='button'
              disabled={employee.seo ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
          {/* <Tooltip  title='edit' placement='rightBottom' className='ms-1'>
            <Button onClick={edit} type='text' htmlType='button'
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<MdEdit />}
            />
          </Tooltip> */}
          </h3>
          {employee.seo && <Button htmlType='button' onClick={edit} icon={<RxUpdate />}>UPDATE</Button>}
        </div>
        
      </div>  
      <div className='mt-5 p-3 bg-white shadow p-3'>
        
        <Form 
          form={form}
          labelAlign='left'
          labelCol={{ span: 8  }}
          labelWrap={true}
          initialValues={employee.seo ? employee : {}}
          // disabled={formValue.status!== 'discard' ? true : false}
          autoComplete="off"
          variant='borderless'
        >
            
          <Row>
            <Col  md={{ span: 11 }}>
              <FloatingLabel
                className='text-2xl'
                variant="standard"
                // disabled={formValue.status!== 'discard' ? true : false}
                placeholder="Name"
                value={name} 
                onChange={onChangeName}
              />
              
            </Col>
            <Col md={{ span: 3, offset: 9 }}>
              <Upload 
                name="picture"
                listType="picture-card"
                className="avatar-uploader"
                showUploadList={false}
                style={{height: '30px'}}
                
              >
                <Avatar icon={<UserOutlined />} />
              </Upload>
            </Col>
          </Row>

          <Row>
            <Col md={{span: 11}}>
              <Form.Item label='Work Phone' name={'work_phone'} className='font-semibold mb-1' required >
                <Input type='tel' className='input-outline-none'/>
              </Form.Item> 
              <Form.Item label='Work Email' name={'work_email'} className='font-semibold mb-1' required >
                <Input type='tel' className='input-outline-none'/>
              </Form.Item> 
            </Col>
            <Col md={{span: 11, offset: 1}}>
              <Form.Item label='Department' name="department_id" className='font-semibold mb-1' required >
                <Select options={departments.map(dept => ({value: dept.id, label: dept.name}))} className='font-normal' />
              </Form.Item>
              <Form.Item label='Manager' name="manager_id" className='font-semibold mb-1' required >
                <Select options={employees.map(employee => ({value: employee.id, label: employee.name}))} className='font-normal' />
              </Form.Item>
            </Col>
          </Row>
          <Tabs
            type='card'
            items={[
              {
                key: '1',
                label: 'Resume',
                children: 
                <div className='p-3'>
                  <Button className='border-0' onClick={openAddContactModal}>ADD</Button>
                </div>
              },
              {
                key: '2',
                label: 'Work Information',
                children: 
                  <Row>
                    
                  </Row>
              },
              {
                key: '3',
                label: 'Private Information',
                forceRender: true,
                children: 
                  <></>
              },
              {
                key: '4',
                label: 'HR Settings',
                children: 
                  <Row>
                    <Col md={{span: 11}}>
                      <Badge className="text-slate-500 text-md bg-transparent	p-0 ">STATUS</Badge>
                      <Form.Item label='Employee Type' name='employee_type_id' className='mb-1 font-semibold'>
                        <Select options={employeeTypes.map(type => ({value: type.id, label: type.name}))} className='font-normal'/>
                      </Form.Item>
                      <Form.Item label='Related User' name='user_id' className='mb-1 font-semibold'>
                        <Select options={users.map(user => ({value: user.id, label: user.name}))} className='font-normal'/>
                      </Form.Item>

                      <Badge className="text-slate-500 text-md bg-transparent	p-0 ">PAYROLL</Badge>
                      <Form.Item label='Job Position' name='job_position_id' className='mb-1 font-semibold'>
                        <Select options={jobPositions.map(job => ({value: job.id, label: job.name}))} className='font-normal'/>
                      </Form.Item>
                      <Form.Item label='Registration Number of Employee' className='mb-1 font-semibold'>
                        <Input type='text' className='input-outline-none'/>
                      </Form.Item>
                    </Col>
                    <Col md={{span: 10, offset: 1}}>
                      <Badge className="text-slate-500 text-md bg-transparent	p-0 ">ATTENDANCE/POINT OF SALES</Badge>
                      <Form.Item label='PIN Code' name='pin_number' className='mb-1 font-semibold'>
                        <Input type='text' className='font-normal input-outline-none'/>
                      </Form.Item>
                    </Col>
                  </Row>
              }
            ]}
          />
        </Form>
      </div>
      {/* <ContactAddress /> */}
    </div>
  )
}

export default EmployeeChanges;